import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import GrupoEmpresasTabla from './GrupoEmpresaTable';

const GrupoEmpresa = (props: any) => {

    const { grupoId, empresas, empresaId, seleccionarEmpresa, deseleccionarEmpresa } = props;


    const dispatch = useDispatch();


    console.log('App loading');



    return (
        <div style={{ width: '100%' }}>
            <GrupoEmpresasTabla empresaId={empresaId} empresas={empresas} seleccionarEmpresa={(empresa: any) => { seleccionarEmpresa(empresa); }} deseleccionarEmpresa={(empresa: any) => { deseleccionarEmpresa(empresa); }} ></GrupoEmpresasTabla>
        </div>
    );
}

export default GrupoEmpresa;
